export const EVENTS = {
    PC_SCREEN_LANDING:
    {
        name: "PC_SCREEN_LANDING",
        schema: "iglu:com.medibuddy/PC_SCREEN_LANDING/jsonschema/2-0-0",
    },
    PC_LS_ACTION:
    {
        name: "PC_LS_ACTION",
        schema: "iglu:com.medibuddy/PC_LS_ACTION/jsonschema/2-0-0",
    },
    APP_VERSION: 'v1.0',
    TAB_NAME_UPCOMING_APPOINTMENTS: 'UPCOMING_APPOINTMENTS',
    TAB_NAME_CANCELLED_APPOINTMENTS: 'CANCELLED_APPOINTMENTS',
    TAB_NAME_COMPLETED_APPOINTMENTS: 'COMPLETED_APPOINTMENTS',
    TAB_NAME_CONFIRMED_APPOINTMENTS: 'CONFIRMED_APPOINTMENTS',
    TAB_NAME_NEW_APPOINTMENTS: 'NEW_APPOINTMENTS',
    TAB_NAME_ALL_APPOINTMENTS: 'ALL_APPOINTMENTS',
    TAB_NAME_DOCUMENTS_SUBMITTED: 'DOCUMENTS_SUBMITTED',
    TAB_NAME_DOCUMENT_UPLOAD: 'DOCUMENT_UPLOAD',
    TAB_NAME_DOCUMENTS_PENDING: 'DOCUMENTS_PENDING',
    TAB_NAME_PARTIAL_DOCUMENTS_SUBMITTED: 'PARTIAL_DOCUMENTS_SUBMITTED',
    TAB_NAME__NOT_ATTENDED: 'NOT_ATTENDED',
    TAB_NAME_REJECTED_APPOINTMENTS: 'REJECTED_APPOINTMENTS',
    TAB_NAME_SETTLED_APPOINTMENTS: 'SETTLED_APPOINTMENTS',
    TAB_NAME_ACTION_PENDING: 'ACTION_PENDING',
    TAB_NAME_PAYMENT_PENDING: 'PAYMENT_PENDING',
    TAB_NAME_MANUFACTURING: 'READY_FOR_MANUFACTURING',
    TAB_NAME_PICKED_FOR_MANUFACTURING: 'PICKED_FOR_MANUFACTURING',
    TAB_NAME_PICKUP: 'READY_FOR_PICKUP',
    TAB_NAME_DELIVERED: 'DELIVERED',
    SERVICE_TYPE_OMS: 'OMS',
    SERVICE_NAME_LABS: "LABS",
    SERVICE_NAME_OFFLINE_CONSULTS: "OFFLINE_CONSULTS",
    SERVICE_NAME_VISION: "VISION",
    ACTION: {
        RESCHEDULE_CLICKED: "RESCHEDULE_CLICKED",
        CONFIRM_CLICKED: "CONFIRM_CLICKED",
        ATTENDED_CLICKED: "ATTENDED_CLICKED",
        NOT_ATTENDED_CLICKED: "NOT_ATTENDED_CLICKED",
        REJECT_CLICKED: "REJECT_CLICKED",
        DOCUMENT_UPLOAD_CLICKED: "DOCUMENT_UPLOAD_CLICKED",
        REJECT_APPOINTMENT_CLICKED: "REJECT_APPOINTMENT_CLICKED",
        BULK_CONFIRM_CLICKED: "BULK_CONFIRM_CLICKED",
        BULK_ATTENDANCE_CLICKED: "BULK_ATTENDANCE_CLICKED",
        SEARCH_ICON_CLICKED: "SEARCH_ICON_CLICKED",
        START_PRODUCTION_CLICKED: "START_PRODUCTION_CLICKED",
        PICKUP_READY_CLICKED: "PICKUP_READY_CLICKED",
        DELIVERED_CLICKED: "DELIVERED_CLICKED",
        INITIATE_PAYMENT_CLICKED: "INITIATE_PAYMENT_CLICKED"
    },
    TAB_NAME: {
        ADD_DOCTOR: "ADD_DOCTOR_PAGE",
        ADD_SCHEDULE: "ADD_SCHEDULE",
        ADD_HOLIDAYS: "ADD_HOLIDAYS",
        ADD_SPOC: "ADD_SPOC",
    }
}